export const BUYER_INTEREST_RANGE_OPTIONS = [
  { value: "7d", labelKey: "buyerInterest.ranges.7d" },
  { value: "30d", labelKey: "buyerInterest.ranges.30d" },
  { value: "all", labelKey: "buyerInterest.ranges.all" },
];

export const DEFAULT_BUYER_INTEREST_RANGE = "30d";

export const BUYER_INTEREST_SORT_OPTIONS = [
  { value: "likes", labelKey: "buyerInterest.sort.likes" },
  { value: "compares", labelKey: "buyerInterest.sort.compares" },
  { value: "watches", labelKey: "buyerInterest.sort.watches" },
  { value: "updated", labelKey: "buyerInterest.sort.updated" },
  { value: "price", labelKey: "buyerInterest.sort.price" },
];

export const DEMAND_SIGNAL_LABEL_KEYS = {
  no_data: "buyerInterest.demand.noData",
  low_interest: "buyerInterest.demand.lowInterest",
  moderate_interest: "buyerInterest.demand.moderateInterest",
  high_interest: "buyerInterest.demand.highInterest",
  price_sensitive: "buyerInterest.demand.priceSensitive",
};

export function trackBuyerInterestEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[dealer-buyer-interest-event]", eventType, metadata);
  }
}

export function formatInterestCount(row, field) {
  const labelKey = `${field}Label`;
  if (row?.[labelKey]) return row[labelKey];
  if (row?.[field] == null) return "<3";
  return String(row[field]);
}
